

export default {
  text: "Banquet",
  key: "menu.banquet",
  level: 1,
  items: [
    {
        icon: "fas fa-chalkboard-teacher",
        key: "menu.banquet",
        text: "Banquet Group List",
        level: 2,
        link: "/banquet/group-list",
        keywords: "Banquet Group List",
        external: true,
      },
      {
        icon: "fas fa-chalkboard-teacher",
        key: "menu.banquet",
        text: "Banquet Reservation List",
        level: 2,
        link: "/banquet/reservation-list",
        keywords: "Banquet Reservation List",
        external: true,
      },
      {
        icon: "mdi-calendar-multiselect",
        key: "menu.banquet",
        text: "Banquet Reservation Calendar",
        level: 2,
        link: "/banquet/reservation-calendar",
        keywords: "Banquet Reservation Calendar",
        external: true,
      },
  ]
};
